export const tagQuestions = [
  {
    questionNumber: 1,
    questionText: "The meeting starts at 10 a.m., doesn't it?",
    choices: {
      A: "The conference room is on the third floor.",
      B: "Yes, that's correct.",
      C: "The office cafeteria closes at 7 p.m.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "회의가 오전 10시에 시작하죠?",
      choices: {
        A: "회의실은 3층에 있습니다.",
        B: "네, 맞습니다.",
        C: "사무실 구내식당은 오후 7시에 문을 닫습니다.",
      },
    },
  },
  {
    questionNumber: 2,
    questionText: "You've already submitted the report, haven't you?",
    choices: {
      A: "I'm still working on it.",
      B: "Yes, I sent it this morning.",
      C: "The report is due next week.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "보고서를 이미 제출하셨죠?",
      choices: {
        A: "아직 작업 중입니다.",
        B: "네, 오늘 아침에 보냈습니다.",
        C: "보고서 마감은 다음 주입니다.",
      },
    },
  },
  {
    questionNumber: 3,
    questionText: "The order has been shipped, hasn't it?",
    choices: {
      A: "The product is available in three colors.",
      B: "I think so, but let me check.",
      C: "The store is open until 8 p.m.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "주문하신 물건이 발송되었죠?",
      choices: {
        A: "상품은 세 가지 색상이 있습니다.",
        B: "그런 것 같은데, 확인해보겠습니다.",
        C: "매장은 오후 8시까지 영업합니다.",
      },
    },
  },
  {
    questionNumber: 4,
    questionText: "He is traveling for business this week, isn't he?",
    choices: {
      A: "The airport has a new lounge.",
      B: "The hotel offers free breakfast.",
      C: "No, his trip was postponed.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "그는 이번 주에 출장 가는 거죠?",
      choices: {
        A: "공항에 새로운 라운지가 있습니다.",
        B: "호텔에서 무료 조식을 제공합니다.",
        C: "아니요, 출장이 연기되었습니다.",
      },
    },
  },
  {
    questionNumber: 5,
    questionText:
      "The new company policy applies to all employees, doesn't it?",
    choices: {
      A: "Yes, it was announced last week.",
      B: "I haven't read the policy yet.",
      C: "The HR department is on the second floor.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "새로운 회사 정책이 모든 직원에게 적용되는 거죠?",
      choices: {
        A: "네, 지난주에 발표되었습니다.",
        B: "아직 정책을 읽지 못했습니다.",
        C: "인사팀은 2층에 있습니다.",
      },
    },
  },
  {
    questionNumber: 6,
    questionText: "The printer is working fine, isn't it?",
    choices: {
      A: "The supply room is next to the break area.",
      B: "No, it keeps jamming.",
      C: "The meeting has been rescheduled.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "프린터가 잘 작동하고 있죠?",
      choices: {
        A: "비품실이 휴게실 옆에 있습니다.",
        B: "아니요, 자꾸 용지가 걸립니다.",
        C: "회의 일정이 변경되었습니다.",
      },
    },
  },
  {
    questionNumber: 7,
    questionText: "John is on vacation this week, isn't he?",
    choices: {
      A: "I'm not sure, let me check the schedule.",
      B: "The HR department manages employee records.",
      C: "The office hours changed last month.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "John이 이번 주에 휴가 중이죠?",
      choices: {
        A: "잘 모르겠네요, 일정을 확인해보겠습니다.",
        B: "HR 부서에서 직원 기록을 관리합니다.",
        C: "사무실 운영 시간이 지난달에 변경되었습니다.",
      },
    },
  },
  {
    questionNumber: 8,
    questionText: "The project deadline is next Friday, isn't it?",
    choices: {
      A: "I haven't checked the schedule yet.",
      B: "Yes, we have until the end of next week.",
      C: "The meeting was rescheduled for Thursday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "프로젝트 마감일이 다음 주 금요일이죠?",
      choices: {
        A: "아직 일정을 확인하지 못했습니다.",
        B: "네, 다음 주 말까지 시간이 있습니다.",
        C: "회의가 목요일로 일정이 변경되었습니다.",
      },
    },
  },
  {
    questionNumber: 9,
    questionText: "She has responded to the email, hasn't she?",
    choices: {
      A: "The IT team maintains the email server.",
      B: "No, she hasn't replied yet.",
      C: "The next meeting is on Wednesday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그녀가 이메일에 답장했죠?",
      choices: {
        A: "IT팀이 이메일 서버를 관리합니다.",
        B: "아니요, 아직 답장하지 않았습니다.",
        C: "다음 회의는 수요일입니다.",
      },
    },
  },
  {
    questionNumber: 10,
    questionText: "The contract includes a confidentiality clause, doesn't it?",
    choices: {
      A: "I think so, but I'll double-check.",
      B: "The legal department reviews all contracts.",
      C: "The company's stock price increased recently.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "계약서에 기밀유지 조항이 포함되어 있죠?",
      choices: {
        A: "그런 것 같은데, 다시 한 번 확인해보겠습니다.",
        B: "법무팀이 모든 계약서를 검토합니다.",
        C: "회사 주가가 최근에 상승했습니다.",
      },
    },
  },
  {
    questionNumber: 11,
    questionText:
      "You've sent the presentation slides to the manager, haven't you?",
    choices: {
      A: "The slides contain financial data.",
      B: "No, I'll send them right away.",
      C: "The office will be closed for maintenance.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "매니저에게 프레젠테이션 슬라이드를 보냈죠?",
      choices: {
        A: "슬라이드에 재무 데이터가 포함되어 있습니다.",
        B: "아니요, 지금 바로 보내겠습니다.",
        C: "사무실이 유지보수로 문을 닫을 예정입니다.",
      },
    },
  },
  {
    questionNumber: 12,
    questionText: "The customer's complaint has been resolved, hasn't it?",
    choices: {
      A: "The customer left a review online.",
      B: "Yes, the issue was fixed this morning.",
      C: "The support team is handling another case.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "고객 불만사항이 해결되었죠?",
      choices: {
        A: "고객이 온라인에 리뷰를 남겼습니다.",
        B: "네, 오늘 아침에 문제가 해결되었습니다.",
        C: "고객지원팀이 다른 건을 처리하고 있습니다.",
      },
    },
  },
  {
    questionNumber: 13,
    questionText: "The hotel booking is confirmed, isn't it?",
    choices: {
      A: "The hotel is located downtown.",
      B: "Yes, I received the confirmation email.",
      C: "I booked a different hotel last time.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "호텔 예약이 확정되었죠?",
      choices: {
        A: "호텔은 시내에 위치해 있습니다.",
        B: "네, 확인 이메일을 받았습니다.",
        C: "지난번에는 다른 호텔을 예약했습니다.",
      },
    },
  },
  {
    questionNumber: 14,
    questionText: "He is responsible for training new employees, isn't he?",
    choices: {
      A: "No, that's handled by the HR department.",
      B: "The new employees start next Monday.",
      C: "The meeting was postponed to Friday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "그가 신입 직원 교육을 담당하고 있죠?",
      choices: {
        A: "아니요, 그건 HR 부서에서 담당합니다.",
        B: "신입 직원들이 다음 주 월요일에 시작합니다.",
        C: "회의가 금요일로 연기되었습니다.",
      },
    },
  },
  {
    questionNumber: 15,
    questionText: "The company installed a new security system, didn't it?",
    choices: {
      A: "The security cameras are quite advanced.",
      B: "Yes, it was set up last month.",
      C: "We need to update the software regularly.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "회사가 새로운 보안 시스템을 설치했죠?",
      choices: {
        A: "보안 카메라가 매우 첨단입니다.",
        B: "네, 지난달에 설치되었습니다.",
        C: "소프트웨어를 정기적으로 업데이트해야 합니다.",
      },
    },
  },
  {
    questionNumber: 16,
    questionText: "The supplier contract has been extended, hasn't it?",
    choices: {
      A: "Yes, it was renewed last week.",
      B: "The procurement team handles contracts.",
      C: "The office layout was redesigned.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "공급업체 계약이 연장되었죠?",
      choices: {
        A: "네, 지난주에 갱신되었습니다.",
        B: "구매팀이 계약을 담당합니다.",
        C: "사무실 레이아웃이 재설계되었습니다.",
      },
    },
  },
  {
    questionNumber: 17,
    questionText: "The project deadline is still the same, isn't it?",
    choices: {
      A: "We have a lot of work left to do.",
      B: "Yes, it hasn't changed.",
      C: "The team is discussing the next steps.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "프로젝트 마감일이 여전히 동일하죠?",
      choices: {
        A: "아직 해야 할 일이 많이 남았습니다.",
        B: "네, 변경되지 않았습니다.",
        C: "팀이 다음 단계를 논의 중입니다.",
      },
    },
  },
  {
    questionNumber: 18,
    questionText: "The meeting isn't scheduled for today, is it?",
    choices: {
      A: "The meeting room is available.",
      B: "The cafeteria serves breakfast until 9 a.m.",
      C: "No, it has been moved to next Monday.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "회의가 오늘로 예정되어 있지 않죠?",
      choices: {
        A: "회의실이 사용 가능합니다.",
        B: "구내식당은 오전 9시까지 아침을 제공합니다.",
        C: "네, 다음 주 월요일로 옮겨졌습니다.",
      },
    },
  },
  {
    questionNumber: 19,
    questionText: "The new office chairs have arrived, haven't they?",
    choices: {
      A: "Yes, they were delivered this morning.",
      B: "The conference room is being renovated.",
      C: "I think they're more comfortable than the old ones.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "새 사무실 의자들이 도착했죠?",
      choices: {
        A: "네, 오늘 아침에 배달되었습니다.",
        B: "회의실이 보수 공사 중입니다.",
        C: "이전 의자들보다 더 편안한 것 같습니다.",
      },
    },
  },
  {
    questionNumber: 20,
    questionText: "She isn't traveling for work this week, is she?",
    choices: {
      A: "No, she canceled her trip.",
      B: "The airport is very busy today.",
      C: "The company announced a new policy.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "그녀가 이번 주에 출장을 가지 않죠?",
      choices: {
        A: "네, 출장을 취소했습니다.",
        B: "오늘 공항이 매우 붐빕니다.",
        C: "회사에서 새로운 정책을 발표했습니다.",
      },
    },
  },
  {
    questionNumber: 21,
    questionText: "The dress code doesn't require formal wear, does it?",
    choices: {
      A: "Yes, business casual is acceptable.",
      B: "The HR team handles all policies.",
      C: "The meeting agenda was updated this morning.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "복장 규정에서 정장을 요구하지 않죠?",
      choices: {
        A: "네, 비즈니스 캐주얼이 허용됩니다.",
        B: "HR팀이 모든 정책을 담당합니다.",
        C: "회의 안건이 오늘 아침에 업데이트되었습니다.",
      },
    },
  },
  {
    questionNumber: 22,
    questionText: "Employees don't have to come in on Fridays, do they?",
    choices: {
      A: "The HR team manages employee schedules.",
      B: "No, remote work is allowed.",
      C: "The office furniture was replaced last month.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "직원들이 금요일에 출근하지 않아도 되죠?",
      choices: {
        A: "HR팀이 직원 일정을 관리합니다.",
        B: "네, 재택근무가 허용됩니다.",
        C: "사무실 가구가 지난달에 교체되었습니다.",
      },
    },
  },
  {
    questionNumber: 23,
    questionText: "You work with the sales team, don't you?",
    choices: {
      A: "Yes, I handle their reports.",
      B: "The sales team has five members.",
      C: "The cafeteria serves lunch until 2 p.m.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "당신은 영업팀과 함께 일하시죠?",
      choices: {
        A: "네, 저는 그들의 보고서를 담당합니다.",
        B: "영업팀은 5명의 팀원이 있습니다.",
        C: "구내식당은 오후 2시까지 점심을 제공합니다.",
      },
    },
  },
  {
    questionNumber: 24,
    questionText: "The printer in the lobby has been fixed, hasn't it?",
    choices: {
      A: "Yes, the technician repaired it this morning.",
      B: "I think we need more paper.",
      C: "The IT department is on the third floor.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "로비에 있는 프린터가 수리되었죠?",
      choices: {
        A: "네, 기술자가 오늘 아침에 수리했습니다.",
        B: "용지를 더 채워넣어야 할 것 같습니다.",
        C: "IT부서는 3층에 있습니다.",
      },
    },
  },
  {
    questionNumber: 25,
    questionText: "You write the monthly report, don't you?",
    choices: {
      A: "The report is due every Friday.",
      B: "No, John is responsible for that.",
      C: "The team meeting was rescheduled.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "당신이 월간 보고서를 작성하시죠?",
      choices: {
        A: "보고서는 매주 금요일이 마감입니다.",
        B: "아니요, John이 그 일을 담당합니다.",
        C: "팀 회의 일정이 변경되었습니다.",
      },
    },
  },
  {
    questionNumber: 26,
    questionText: "They finish their projects on time, don't they?",
    choices: {
      A: "The next milestone is next month.",
      B: "No, we still have a few tasks left.",
      C: "The cafeteria is serving a new menu today.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그들은 프로젝트를 제시간에 끝내죠?",
      choices: {
        A: "다음 마일스톤은 다음 달입니다.",
        B: "아니요, 아직 몇 가지 작업이 남아있습니다.",
        C: "구내식당이 오늘 새로운 메뉴를 제공합니다.",
      },
    },
  },
  {
    questionNumber: 27,
    questionText: "The concert tickets are still available, aren't they?",
    choices: {
      A: "Yes, but only a few seats are left.",
      B: "I watched that band last year.",
      C: "The concert hall is near the subway station.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "콘서트 티켓이 아직 남아있죠?",
      choices: {
        A: "네, 하지만 좌석이 얼마 남지 않았습니다.",
        B: "작년에 그 밴드 공연을 봤습니다.",
        C: "공연장이 지하철역 근처에 있습니다.",
      },
    },
  },
  {
    questionNumber: 28,
    questionText: "Mark is in the office today, isn't he?",
    choices: {
      A: "Yes, I saw him this morning.",
      B: "The office closes at 6 PM.",
      C: "He usually works from home on Fridays.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "Mark가 오늘 사무실에 있죠?",
      choices: {
        A: "네, 오늘 아침에 봤습니다.",
        B: "사무실은 오후 6시에 문을 닫습니다.",
        C: "그는 보통 금요일에는 재택근무를 합니다.",
      },
    },
  },
  {
    questionNumber: 29,
    questionText: "The package should have arrived by now, shouldn't it?",
    choices: {
      A: "Let me check with the delivery service.",
      B: "Yes, it was delivered this morning.",
      C: "The warehouse is running low on stock.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "패키지가 지금쯤 도착했어야 하죠?",
      choices: {
        A: "배송 서비스에 확인해보겠습니다.",
        B: "네, 오늘 아침에 배달되었습니다.",
        C: "창고의 재고가 부족한 상황입니다.",
      },
    },
  },
  {
    questionNumber: 30,
    questionText: "Business casual is acceptable for the office, isn't it?",
    choices: {
      A: "Yes, it's part of the company dress code.",
      B: "The office is on the 10th floor.",
      C: "I bought a new suit for the meeting.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "사무실에서 비즈니스 캐주얼이 허용되죠?",
      choices: {
        A: "네, 회사 복장 규정에 포함되어 있습니다.",
        B: "사무실은 10층에 있습니다.",
        C: "회의를 위해 새 정장을 샀습니다.",
      },
    },
  },
];
